'use client';

import { useEffect, useTransition } from 'react';

import { useGlobalLoaderContext } from '@module/mdrt-org/shared/components/providers/global-loader-context';

import { useGlobalCmsContentContext } from '../../components/providers/global-cms-context';
import { usePathname, useRouter } from '../../i18n/i18n-navigation';

export const useLanguageSwitcher = () => {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const { cmsPaths } = useGlobalCmsContentContext();
  const { setIsNonBlockingLoaderVisible } = useGlobalLoaderContext();
  const pathname = usePathname();

  const shouldResetSearchParameters = pathname === cmsPaths.searchPagePath; // this is a workaround for the search page, where we need to reset the search parameters when changing the language

  const onLanguageChange = (locale: string) => {
    const parameters = new URLSearchParams(window.location.search);
    const newPathWithSearchParameters = parameters.toString()
      ? `${pathname}?${parameters.toString()}`
      : pathname;
    startTransition(() => {
      router.replace(shouldResetSearchParameters ? pathname : newPathWithSearchParameters, {
        locale,
      });
    });
  };

  useEffect(() => {
    setIsNonBlockingLoaderVisible(isPending);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPending]);

  return { onLanguageChange };
};
